import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const networkRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'your-view',
        loadComponent: () =>
          import('./networth.component').then((m) => m.NetworthComponent),
        data: { tab: 0 },
      },
      {
        path: 'consolidated-view',
        loadComponent: () =>
          import('./networth.component').then((m) => m.NetworthComponent),
        data: { tab: 1 },
      },
      { path: '**', pathMatch: 'full', redirectTo: 'your-view' },
    ],
  },
];
